import React from 'react';
import {
  SpinnerContainer,
  SpinnerText,
  Spinner
} from './styles';

export default class Loading extends React.Component {

  render = () => (
    <SpinnerContainer>
      <SpinnerText>Töltögetünk...</SpinnerText>
      <Spinner><div/><div/></Spinner>
    </SpinnerContainer>
  );

}



// WEBPACK FOOTER //
// ./src/components/Loading/index.js